import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-3 font-heading">{contactData.title}</h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto leading-relaxed">{contactData.description}</p>
        </div>
        <div className="max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-4">
          {contactData.items.map((item) => (
            <div key={item.label} className="bg-background-100 rounded-lg p-6 text-center border border-background-200/70">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className={`${item.icon} text-xl text-secondary-600`}></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">{item.label}</div>
              <div className="text-sm font-medium text-foreground-900 break-all">{item.value}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}